import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { tokens } from "../../../theme";
import { useTheme } from "@mui/material";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import useMediaQuery from '@mui/material/useMediaQuery';
import Axios from 'axios';
import ErrorSnackbar from '../../../components/ErrorSnackbar';
import UploadComp from '../../../components/UploadComp';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
// import OutlinedInput from '@mui/material/OutlinedInput';
// import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
// import FormLabel from '@mui/material/FormLabel';
import Autocomplete from '@mui/material/Autocomplete';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import FormControlLabel from '@mui/material/FormControlLabel';
import dayjs from 'dayjs';
import { getAuthHeader } from '../../../utils/authToken';
import QuestionRender from '../../../components/QuestionRender';
import { Document, Page, pdfjs } from "react-pdf";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Chip from '@mui/material/Chip';
import { CoordinateGrid, formatElementSummary, parseCoordinateAnswerForDisplay } from '../../../components/coordinateGrid';
import { TableReadOnly, defaultTableConfig } from '../../../components/tableAnswer';
import { MappingReadOnly, defaultMappingConfig } from '../../../components/mappingAnswer';
import { PolynomialGraphReadOnly, defaultPolynomialGraphConfig } from '../../../components/polynomialGraph';
import { RationalGraphReadOnly, defaultRationalGraphConfig } from '../../../components/rationalGraph';
import { TrigGraphReadOnly, defaultTrigGraphConfig } from '../../../components/trigGraph';
import { MultilineReadOnly, defaultMultilineConfig } from '../../../components/multiline';
import { NumberLineReadOnly, defaultNumberLineConfig } from '../../../components/numberLine';
import { MATHLIVE_ANSWER_TYPES, parseMathliveAnswer } from '../../../components/mathlive';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone');

dayjs.extend(utc)
dayjs.extend(timezone)


// Helper to format coordinate answer for display
const formatCoordinateAnswerDisplay = (answer, config, _colors) => {
    const parsed = parseCoordinateAnswerForDisplay(answer, config, 150);
    if (!parsed) return null;

    const { elements, gridConfig, gridSize } = parsed;

    return (
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-start', mt: 1 }}>
            <CoordinateGrid
                config={gridConfig}
                elements={elements}
                pendingPoints={[]}
                mode="point"
                readOnly={true}
                width={gridSize}
                height={gridSize}
            />
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
                {elements.map((el, i) => (
                    <Chip
                        key={el.id || i}
                        label={formatElementSummary(el)}
                        size="small"
                        sx={{ fontSize: '0.7rem' }}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default function AdminActionAccordion({
    courseId,
    students,
    userRole,
    studentsStartEndDateMap,
    authorDisabledForAdminActions,
    lectureModules,
    setBackdropOpen,
    setSuccessAlertOpen,
    setErrorAlertOpen,
    setSuccessAlertMessage,
    setErrorAlertMessage,
    classMaterials,
    allowFileUpload = true,
    allowHwQuestions = true,
}) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [files, setFiles] = React.useState([]);
    const [dueDate, setDueDate] = React.useState(null);
    const [lecture, setLecture] = React.useState('');
    const [errorSnackbarOpen, setErrorSnackbarOpen] = React.useState(false);
    const matches = useMediaQuery('(min-width:90rem)');
    const [tinyLoading, setTinyLoading] = React.useState(false);

    const [materialChoice, setMaterialChoice] = React.useState('file_upload'); // ['file_upload', 'hw_questions']
    const [classMaterial, setClassMaterial] = React.useState(null);
    const [pageRanges, setPageRanges] = React.useState([{ from: 0, to: 0 }]);
    const [hwQuestions, setHwQuestions] = React.useState([]);
    const [excludedQuestions, setExcludedQuestions] = React.useState([]);
    const [excludedQuestionLabels, setExcludedQuestionLabels] = React.useState([]);
    const [selectedStudents, setSelectedStudents] = React.useState([]);

    // PDF viewer state
    const [showPDF, setShowPDF] = React.useState(false);
    const [selectedPDFPage, setSelectedPDFPage] = React.useState(1);
    const [numPDFPages, setNumPDFPages] = React.useState(null);

    // Memoize pdf.js options to prevent re-triggering Document load on every render.
    // disableAutoFetch stops pdf.js from pre-downloading all pages after the first loads.
    const pdfOptions = React.useMemo(() => ({
        disableAutoFetch: true,
        disableStream: false,
    }), []);

    // for teachers and admins
    const [lectureStartdate, setLectureStartdate] = React.useState(dayjs());

    // Close PDF on Escape key
    React.useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === 'Escape' && showPDF) {
                setShowPDF(false);
            }
        };

        window.addEventListener('keydown', handleEscape);
        return () => window.removeEventListener('keydown', handleEscape);
    }, [showPDF]);

    React.useEffect(() => {
        lectureModules.forEach((module) => {
            if (module.id === lecture) {
                setLectureStartdate(module.start.split("T")[0]);
            }
        });
    }, [lecture]);

    // Auto-select available homework type for teachers when current selection is unavailable
    React.useEffect(() => {
        if (userRole === 'teacher') {
            // If current selection is file_upload but it's disabled, switch to hw_questions
            if (materialChoice === 'file_upload' && !allowFileUpload && allowHwQuestions) {
                setMaterialChoice('hw_questions');
            }
            // If current selection is hw_questions but it's disabled, switch to file_upload
            else if (materialChoice === 'hw_questions' && !allowHwQuestions && allowFileUpload) {
                setMaterialChoice('file_upload');
            }
        }
    }, [userRole, allowFileUpload, allowHwQuestions, materialChoice]);

    let current_students = [];
    if (students !== null && students !== undefined) {
        for (let i = 0; i < students.length; i++) {
            const end_date = dayjs(studentsStartEndDateMap[students[i].id].end_date);
            const start_date = dayjs(studentsStartEndDateMap[students[i].id].start_date);
        
            if (dayjs(lectureStartdate).isAfter(end_date) || dayjs(lectureStartdate).isBefore(start_date)) {
                continue;
            }
            current_students.push(students[i]);
        }
    }
    

    const handleLectureChange = (event) => {
        event.preventDefault();
        setLecture(event.target.value);
    };

    // Page range helper functions
    const addPageRange = () => {
        setPageRanges([...pageRanges, { from: 0, to: 0 }]);
        setExcludedQuestions([]);
        setExcludedQuestionLabels([]);
    };

    const removePageRange = (index) => {
        if (pageRanges.length > 1) {
            const updated = pageRanges.filter((_, i) => i !== index);
            setPageRanges(updated);
            const validRanges = updated.filter(r => r.from > 0 && r.to >= r.from);
            if (validRanges.length > 0) {
                fetchHWQuestionsWithRanges(validRanges);
            } else {
                setHwQuestions([]);
            }
            setExcludedQuestions([]);
            setExcludedQuestionLabels([]);
        }
    };

    const updatePageRange = (index, field, value) => {
        const updated = [...pageRanges];
        updated[index] = { ...updated[index], [field]: parseInt(value) || 0 };

        if (field === 'from') {
            updated[index].to = 0;
        }

        setPageRanges(updated);
        setExcludedQuestions([]);
        setExcludedQuestionLabels([]);

        if (field === 'to' && value > 0) {
            const validRanges = updated.filter(r => r.from > 0 && r.to >= r.from);
            if (validRanges.length > 0) {
                fetchHWQuestionsWithRanges(validRanges);
            }
        }
    };

    const getSelectedPages = () => {
        const pages = new Set();
        pageRanges.forEach(range => {
            if (range.from > 0 && range.to >= range.from) {
                for (let p = range.from; p <= range.to; p++) {
                    pages.add(p);
                }
            }
        });
        return Array.from(pages).sort((a, b) => a - b);
    };

    const hasValidRanges = () => {
        return pageRanges.some(r => r.from > 0 && r.to >= r.from);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (lecture === '') {
            setErrorSnackbarOpen(true);
            return;
        }

        if (dueDate === null) {
            setErrorSnackbarOpen(true);
            return;
        }

        if (!dueDate.isValid()) {
            setErrorAlertMessage("Please select a valid due date!");
            setErrorAlertOpen(true);
            return;
        }          

        if (materialChoice === 'hw_questions' && (classMaterial === null || classMaterial === '')) {
            setErrorAlertMessage("Please select class material!");
            setErrorAlertOpen(true);
            return;
        }

        if (materialChoice === 'hw_questions' && !hasValidRanges()) {
            setErrorAlertMessage("Please select at least one valid page range!");
            setErrorAlertOpen(true);
            return;
        }

        if (materialChoice === 'hw_questions' && hwQuestions.filter(q => !excludedQuestions.includes(q.id)).length === 0) {
            setErrorAlertMessage("The selected pages do not contain any questions. Please select pages with at least one question included.");
            setErrorAlertOpen(true);
            return;
        }

        let selected_students = "";
        let unselected_students = "";

        // selected한 학생이 없으면 select에 있는 모든 학생에게 숙제 부여한다
        if (selectedStudents === null || selectedStudents.length === 0) {            
            for (let i = 0; i < current_students.length; i++) {
                selected_students += current_students[i].id;
                if (i !== current_students.length - 1) {
                    selected_students += "|";
                }
            }
        }
        // selected한 학생이 있으면 select에 있는 학생에게만 숙제 부여
        if (selectedStudents !== null && selectedStudents.length > 0) {
            for (let i = 0; i < selectedStudents.length; i++) {
                selected_students += selectedStudents[i].id;
                if (i !== selectedStudents.length - 1) {
                    selected_students += "|";
                }
            }
        }
        let students_list = [];
        for (let i = 0; i < current_students.length; i++) {
            students_list.push(current_students[i].id);
        }
        
        const selectedStudentsList = selected_students?.split("|")?.toString();
        const unselectedFilter = students_list.filter(item => !selectedStudentsList.includes(item));

        for (let i = 0; i < unselectedFilter.length; i++) {
            unselected_students += unselectedFilter[i];
            if (i !== unselectedFilter.length - 1) {
                unselected_students += "|";
            }
        }
                     
        setBackdropOpen(true);

        const data = new FormData(event.currentTarget);
        if (materialChoice !== 'hw_questions') {
            // normal homework (file upload or only title and instructions)
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                if (files[i].name !== undefined 
                    && files[i].name !== null 
                    && files[i].name !== ""
                    && files[i].name.length > 150) {
                    setErrorAlertMessage("File name should be less than 150 characters!");
                    setErrorAlertOpen(true);
                    setBackdropOpen(false);
                    return;
                }
                formData.append('file', files[i], files[i].name);
            }

            formData.append('title', data.get('title'));
            formData.append('posted_by', data.get('author'));
            formData.append('content', data.get('instructions'));
            formData.append('due_date', dueDate);
            formData.append('exclude_student', unselected_students);
            formData.append('unexclude_student', selected_students);
        
            await Axios.post(`${process.env.REACT_APP_URL}/api/v1/courses/${courseId}/events/${lecture}/homeworks`, formData, {
                headers: {
                    Authorization: getAuthHeader(),
                    'Content-Type': 'multipart/form-data',
                },
            }
            ).then(async (response) => {
                setBackdropOpen(false);
                setSuccessAlertMessage("Homework created successfully!");
                setSuccessAlertOpen(true);                

                const homework_id = response.data.homework_id;
                if (homework_id) {
                    await Axios.post(`${process.env.REACT_APP_URL}/api/v1/mails/courses/${courseId}/homeworks/${homework_id}`, {
                        // no params but still need this bracket for headers
                        selected_students: selected_students,
                    }, {
                        headers: {
                            Authorization: getAuthHeader(),                            
                        },
                    }).then((res) => {
                        // return;
                        window.location.reload();
                    }).catch((error) => {
                        console.log(error);
                        setErrorAlertMessage(error.response?.data?.message || error.response?.data?.error || "Something went wrong");
                        setErrorAlertOpen(true);
                    });
                } else {
                    window.location.reload();
                }
            }).catch((error) => {
                console.log(error);
                setBackdropOpen(false);
                setErrorAlertMessage(error.response?.data?.message || error.response?.data?.error || "Something went wrong");
                setErrorAlertOpen(true);
            });
        } else {
            const title = data.get('title');
            const posted_by = data.get('author');
            const content = data.get('instructions');
            const due_date = dueDate;
            const pages = getSelectedPages();
            const exceptions = excludedQuestions; // Send as array directly
            const exclude_student = unselected_students;
            const unexclude_student = selected_students;


            // class material homework
            await Axios.post(`${process.env.REACT_APP_URL}/api/v1/courses/${courseId}/events/${lecture}/homeworks/class-materials/${classMaterial.id}`, {
                title,
                posted_by,
                content,
                due_date,
                pages,
                exceptions,
                exclude_student,
                unexclude_student
            }, {
                headers: {
                    Authorization: getAuthHeader(),
                },
            }).then(async (response) => {
                setBackdropOpen(false);
                setSuccessAlertMessage("Homework created successfully!");
                setSuccessAlertOpen(true);

                const homework_id = response.data.homework_id;
                if (homework_id) {
                    await Axios.post(`${process.env.REACT_APP_URL}/api/v1/mails/courses/${courseId}/homeworks/${homework_id}`, {
                        // no params but still need this bracket for headers
                        selected_students: selected_students,
                    }, {
                        headers: {
                            Authorization: getAuthHeader(),
                        },
                    }).then((res) => {
                        window.location.reload();
                    }).catch((error) => {
                        console.log(error);
                        setErrorAlertMessage(error.response?.data?.message || error.response?.data?.error || "Something went wrong");
                        setErrorAlertOpen(true);
                    });
                } else {
                    window.location.reload();
                }
            }).catch((error) => {
                console.log(error);
                setBackdropOpen(false);
                setErrorAlertMessage(error.response?.data?.message || error.response?.data?.error || "Something went wrong");
                setErrorAlertOpen(true);
            });
        }
    };

    const fetchHWQuestionsWithRanges = async (ranges) => {
        if (classMaterial === null || classMaterial === '') {
            setErrorAlertMessage("Please select class material!");
            setErrorAlertOpen(true);
            return;
        }

        if (classMaterial.textbook_id === null || classMaterial.textbook_id === '') {
            setErrorAlertMessage("There are no questions for this class material in the database!");
            setErrorAlertOpen(true);
            return;
        }

        // Get all pages from all valid ranges
        const pages = [];
        ranges.forEach(range => {
            if (range.from > 0 && range.to >= range.from) {
                for (let p = range.from; p <= range.to; p++) {
                    if (!pages.includes(p)) pages.push(p);
                }
            }
        });

        if (pages.length === 0) {
            return;
        }

        setTinyLoading(true);

        await Axios.get(`${process.env.REACT_APP_URL}/api/v1/hw-questions`, {
            params: {
                textbook_id: classMaterial.textbook_id,
                pages: pages.join(','),
            },
            headers: {
                Authorization: getAuthHeader(),
            },
        }).then((response) => {
            setHwQuestions(response.data);
        }).catch((error) => {
            console.log(error);
            setErrorAlertMessage(error.response?.data?.message || error.response?.data?.error || "Error fetching questions");
            setErrorAlertOpen(true);
        });

        setTinyLoading(false);
    };

    return (
        <div style={{
            width: "100%",
            marginBottom: "1rem",
        }}>
            <Accordion
                style={{
                    backgroundColor: colors.primary[750],
                }}
                component="div"
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography variant='h6'>Create Homework</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box
                        component="form"
                        sx={{
                            '& > :not(style)': { m: 1, width: '25ch' },
                            display: "flex",
                            flexDirection: "column",
                            mr: "1rem",
                        }}
                        noValidate
                        autoComplete="off"
                        onSubmit={handleSubmit}
                    >
                        <FormControl fullWidth sx={{ minWidth: "49%", backgroundColor: colors.primary[600] }}>
                            <InputLabel id="demo-simple-select-label">Select a module</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={lecture}
                                label="Select a module"
                                onChange={handleLectureChange}
                            >
                                {lectureModules.map((lectureModule) => {
                                    return (
                                        <MenuItem key={lectureModule.id} value={lectureModule.id}>
                                            {lectureModule.title}, {new Date(lectureModule.start).toDateString()}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                minWidth: "100%",
                            }}
                        >
                            <Typography variant="h6" color="text.secondary">
                                Please set the due date for homework to be one day before your class at 11:55 PM (ET). <br />
                                (e.g Class Date: Friday, 10/11 Due Date: Thursday, 10/10, at 11:55 PM (ET))
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: 2,
                                minWidth: "100%",
                            }}
                        >
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DateTimePicker
                                    label="Due Date"
                                    value={dueDate}
                                    onChange={(newValue) => setDueDate(newValue)}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            backgroundColor: colors.primary[600],
                                            width: "16rem",
                                            ...!matches && {
                                                width: "100%",
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                            <TextField
                                id="filled-basic"
                                label="NY Time"
                                variant="outlined"
                                disabled
                                value={dayjs(dueDate).tz('America/New_York').format('MM/DD/YYYY HH:mm')}
                            />
                        </Box>

                        {/* Material Choice Selector */}
                        <Box sx={{ mt: 2, mb: 2, minWidth: "100%", }}>
                            <Typography variant="h6" mb={1}>
                                Homework Type:
                            </Typography>
                            {/* Check if teacher has any options available */}
                            {userRole === 'teacher' && !allowFileUpload && !allowHwQuestions ? (
                                <Typography variant="body1" color="error" sx={{ mt: 1 }}>
                                    No homework types are currently enabled for teachers. Please contact an admin.
                                </Typography>
                            ) : (
                                <FormControl component="fieldset" disabled={!lecture || !dueDate}>
                                    <RadioGroup
                                        row
                                        value={materialChoice}
                                        onChange={(e) => setMaterialChoice(e.target.value)}
                                    >
                                        {/* Admin always sees file upload, teacher only if allowed */}
                                        {(userRole === 'admin' || allowFileUpload) && (
                                            <FormControlLabel
                                                value="file_upload"
                                                control={<Radio />}
                                                label="File Upload (Traditional)"
                                            />
                                        )}
                                        {/* Admin always sees hw_questions, teacher only if allowed */}
                                        {(userRole === 'admin' || allowHwQuestions) && (
                                            <FormControlLabel
                                                value="hw_questions"
                                                control={<Radio />}
                                                label="HW Questions (From Textbook)"
                                            />
                                        )}
                                    </RadioGroup>
                                </FormControl>
                            )}
                            {(!lecture || !dueDate) && (
                                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                                    Please select a module and due date first
                                </Typography>
                            )}
                        </Box>

                        <Box sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            minWidth: "100%",
                        }}>
                            <TextField
                                id="filled-basic"
                                label="Title"
                                variant="filled"
                                name='title'
                                sx={{
                                    flex: "1",
                                    maxWidth: "50%",
                                    '& .MuiFilledInput-root': {
                                        backgroundColor: colors.primary[600],
                                        ":focus": {
                                            backgroundColor: 'white',
                                        },
                                    },
                                }}
                            />
                            <TextField
                                id="filled-basic"
                                label="Author"
                                variant="filled"
                                name='author'
                                sx={{
                                    flex: "1",
                                    maxWidth: "50%",
                                    '& .MuiFilledInput-root': {
                                        backgroundColor: colors.primary[600],
                                        ":focus": {
                                            backgroundColor: 'white',
                                        },
                                    },
                                }}
                                defaultValue={localStorage.getItem('userName')}
                                inputProps={{ readOnly: authorDisabledForAdminActions }}
                            />
                        </Box>
                        {userRole === 'admin' ? (
                            <Box sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "1rem",
                                minWidth: "100%",
                            }}>
                                {/* For admin */}
                                {/* a list of students*/}
                                <Autocomplete
                                    disabled={lecture === null || lecture === '' ? true : false}
                                    multiple
                                    limitTags={4}
                                    id="student-list"
                                    options={current_students !== null ? current_students : []}
                                    getOptionLabel={(current_students) => current_students.first_name + " " + current_students.last_name}
                                    getOptionKey={(student) => student.id}
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="숙제를 부여할 학생 (아무도 선택하지 않거나 모두 선택하면 모든 학생에게 숙제가 부여됩니다)"
                                            // label="Select students to exclude from this homework"
                                        />
                                    )}
                                    sx={{ width: "100%" }}
                                    onChange={(event, value) => {
                                        setSelectedStudents(value);
                                    }}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                />
                            </Box>
                            ) : (
                            <></>
                            )
                        }
                        <TextField
                            id="filled-basic"
                            label="Instructions"
                            variant="filled"
                            name='instructions'
                            fullWidth={true}
                            multiline={true}
                            rows={10}
                            sx={{
                                minWidth: "100%",
                                borderRadius: "5px",
                                '& .MuiFilledInput-root': {
                                    backgroundColor: colors.primary[600],
                                    ":focus": {
                                        backgroundColor: 'white',
                                    },
                                },
                            }}
                        />
                        {/* <FormControl style={{ width: '100%', marginTop: '20px' }}>
                            <FormLabel id="demo-radio-buttons-group-label">Homework Type</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                value={materialChoice}
                                name="controlled-radio-buttons-group"
                                row
                                onChange={(e) => setMaterialChoice(e.target.value)}
                                style={{
                                    display: "flex",
                                }}
                            >
                                <FormControlLabel value="file upload" control={<Radio />} label="default" />
                                <FormControlLabel value="class material" control={<Radio />} label="Class Material" />
                            </RadioGroup>
                        </FormControl> */}
                        {materialChoice === 'hw_questions' ? (<>
                            <Box
                                display="flex"
                                minWidth="100%"
                                justifyContent="flex-start"
                                sx={{
                                    gap: "1rem",
                                }}
                            >
                                <FormControl fullWidth sx={{ maxWidth: "49%", backgroundColor: colors.primary[600] }}>
                                    <InputLabel id="demo-simple-select-label">Class Material</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={classMaterial ? classMaterial : ''}
                                        label="Select a class material"
                                        onChange={(e) => {
                                            setClassMaterial(e.target.value);
                                            setPageRanges([{ from: 0, to: 0 }]);
                                            setHwQuestions([]);
                                            setExcludedQuestions([]);
                                            setExcludedQuestionLabels([]);
                                        }}
                                    >
                                        <MenuItem value={''}>
                                            None
                                        </MenuItem>
                                        {classMaterials.filter(cm => cm.textbook_id && !(cm.name || '').toLowerCase().includes('_share')).map((classMaterial) => {
                                            return (
                                                <MenuItem key={classMaterial.id} value={classMaterial}>
                                                    {classMaterial.name}
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                            </Box>
                            {classMaterial && classMaterial !== null ? (<>
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    minWidth="100%"
                                    sx={{ gap: "0.5rem" }}
                                >
                                    <Typography variant="subtitle2" color="text.secondary">
                                        Page Ranges:
                                    </Typography>

                                    {pageRanges.map((range, index) => (
                                        <Box
                                            key={index}
                                            display="flex"
                                            alignItems="center"
                                            sx={{ gap: "1rem" }}
                                        >
                                            <FormControl sx={{ minWidth: 120, backgroundColor: colors.primary[600] }}>
                                                <InputLabel>From</InputLabel>
                                                <Select
                                                    value={range.from}
                                                    label="From"
                                                    onChange={(e) => updatePageRange(index, 'from', e.target.value)}
                                                >
                                                    <MenuItem value={0}>None</MenuItem>
                                                    {Array.from({ length: classMaterial?.textbook?.pages }, (_, i) => i + 1).map((page) => (
                                                        <MenuItem key={page} value={page}>{page}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>

                                            <Typography>→</Typography>

                                            <FormControl sx={{ minWidth: 120, backgroundColor: colors.primary[600] }}>
                                                <InputLabel>To</InputLabel>
                                                <Select
                                                    value={range.to}
                                                    label="To"
                                                    onChange={(e) => updatePageRange(index, 'to', e.target.value)}
                                                    disabled={range.from === 0}
                                                >
                                                    <MenuItem value={0}>None</MenuItem>
                                                    {Array.from({ length: classMaterial?.textbook?.pages }, (_, i) => i + 1)
                                                        .filter(page => page >= range.from)
                                                        .map((page) => (
                                                            <MenuItem key={page} value={page}>{page}</MenuItem>
                                                        ))}
                                                </Select>
                                            </FormControl>

                                            {pageRanges.length > 1 && (
                                                <IconButton
                                                    onClick={() => removePageRange(index)}
                                                    size="small"
                                                    sx={{ color: colors.redAccent[400] }}
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            )}
                                        </Box>
                                    ))}

                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={addPageRange}
                                        sx={{
                                            alignSelf: 'flex-start',
                                            mt: 1,
                                            color: colors.greenAccent[400],
                                            borderColor: colors.greenAccent[400],
                                        }}
                                    >
                                        + Add Page Range
                                    </Button>

                                    {hasValidRanges() && (
                                        <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
                                            Selected pages: {getSelectedPages().join(', ')}
                                        </Typography>
                                    )}
                                </Box>
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    minWidth="100%"
                                    justifyContent="flex-start"
                                    position="relative"
                                    sx={{
                                        gap: "1rem",
                                    }}
                                >
                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                        <Typography variant="h6" color="text.secondary">
                                            Total Questions: {hwQuestions.length}
                                        </Typography>
                                        {hwQuestions.length > 0 && (
                                            <Button
                                                variant="outlined"
                                                startIcon={showPDF ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                                onClick={() => {
                                                    setShowPDF(!showPDF);
                                                    if (!showPDF && hwQuestions.length > 0) {
                                                        // Set initial PDF page to the first question's page
                                                        setSelectedPDFPage(hwQuestions[0].page);
                                                    }
                                                }}
                                                sx={{
                                                    color: colors.greenAccent[400],
                                                    borderColor: colors.greenAccent[400],
                                                    '&:hover': {
                                                        borderColor: colors.greenAccent[300],
                                                        backgroundColor: colors.greenAccent[900],
                                                    },
                                                }}
                                            >
                                                {showPDF ? 'Hide PDF' : 'Show PDF'}
                                            </Button>
                                        )}
                                    </Box>
                                    {tinyLoading ? (
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                width: '20px',
                                                height: '20px',
                                                zIndex: 1000,
                                            }}
                                        >
                                            <CircularProgress color="inherit" size={20} />
                                        </Box>
                                    ) : null}
                                    {hwQuestions.length > 0 && !tinyLoading && (
                                        <Box sx={{ mt: 2, position: 'relative', width: '100%' }}>
                                            {/* Backdrop */}
                                            {showPDF && (
                                                <Box
                                                    onClick={() => setShowPDF(false)}
                                                    sx={{
                                                        position: 'fixed',
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                        zIndex: 9998,
                                                        transition: 'opacity 0.3s ease',
                                                        opacity: showPDF ? 1 : 0,
                                                    }}
                                                />
                                            )}

                                            {/* PDF Viewer - Slide in from right */}
                                            {classMaterial?.file_url && (
                                                <Box
                                                    sx={{
                                                        position: 'fixed',
                                                        top: 0,
                                                        right: 0,
                                                        height: '100vh',
                                                        width: '70%',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: 2,
                                                        padding: '20px',
                                                        backgroundColor: colors.primary[600],
                                                        boxShadow: '-4px 0 20px rgba(0, 0, 0, 0.5)',
                                                        zIndex: 9999,
                                                        transform: showPDF ? 'translateX(0)' : 'translateX(100%)',
                                                        transition: 'transform 0.3s ease-in-out',
                                                        overflowY: 'auto',
                                                    }}
                                                >
                                                    {/* Close button - top left */}
                                                    <IconButton
                                                        onClick={() => setShowPDF(false)}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: '10px',
                                                            left: '10px',
                                                            color: colors.primary[100],
                                                            backgroundColor: colors.greenAccent[600],
                                                            '&:hover': {
                                                                backgroundColor: colors.greenAccent[700],
                                                            },
                                                            zIndex: 10,
                                                        }}
                                                    >
                                                        <ChevronRightIcon />
                                                    </IconButton>

                                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} mt={5}>
                                                        <Typography variant="h5" fontWeight="bold">
                                                            Textbook Preview
                                                        </Typography>
                                                        <Typography variant="body1" color="text.secondary">
                                                            Page {selectedPDFPage} / {numPDFPages || '?'}
                                                        </Typography>
                                                    </Box>
                                                    <Divider />
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'flex-start',
                                                            flex: 1,
                                                            mt: 2,
                                                        }}
                                                    >
                                                        <Document
                                                            file={classMaterial.file_url}
                                                            options={pdfOptions}
                                                            onLoadSuccess={({ numPages }) => {
                                                                setNumPDFPages(numPages);
                                                            }}
                                                            onLoadError={(error) => {
                                                                console.error('PDF load error:', error);
                                                                setErrorAlertMessage(`Failed to load PDF: ${error.message}`);
                                                                setErrorAlertOpen(true);
                                                            }}
                                                            loading={
                                                                <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                                                                    <CircularProgress />
                                                                </Box>
                                                            }
                                                        >
                                                            <Page
                                                                pageNumber={selectedPDFPage}
                                                                renderTextLayer={false}
                                                                renderAnnotationLayer={false}
                                                                width={400}
                                                            />
                                                        </Document>
                                                    </Box>
                                                    <Box display="flex" justifyContent="center" gap={2} mt={1}>
                                                        <Button
                                                            variant="contained"
                                                            startIcon={<NavigateBeforeIcon />}
                                                            onClick={() => setSelectedPDFPage(Math.max(1, selectedPDFPage - 1))}
                                                            disabled={selectedPDFPage <= 1}
                                                            sx={{
                                                                backgroundColor: colors.greenAccent[600],
                                                                color: colors.primary[100],
                                                                '&:hover': {
                                                                    backgroundColor: colors.greenAccent[700],
                                                                },
                                                                '&:disabled': {
                                                                    backgroundColor: colors.grey[700],
                                                                    color: colors.grey[500],
                                                                },
                                                            }}
                                                        >
                                                            Previous
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            endIcon={<NavigateNextIcon />}
                                                            onClick={() => setSelectedPDFPage(Math.min(numPDFPages || selectedPDFPage, selectedPDFPage + 1))}
                                                            disabled={selectedPDFPage >= (numPDFPages || selectedPDFPage)}
                                                            sx={{
                                                                backgroundColor: colors.greenAccent[600],
                                                                color: colors.primary[100],
                                                                '&:hover': {
                                                                    backgroundColor: colors.greenAccent[700],
                                                                },
                                                                '&:disabled': {
                                                                    backgroundColor: colors.grey[700],
                                                                    color: colors.grey[500],
                                                                },
                                                            }}
                                                        >
                                                            Next
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            )}

                                            {/* Questions List */}
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
                                                <Typography variant="h6" fontWeight="bold">
                                                    Loaded Questions ({hwQuestions.filter(q => !excludedQuestions.includes(q.id)).length} included / {hwQuestions.length} total)
                                                </Typography>

                                                {hwQuestions.map((question) => (
                                                <Card
                                                    key={question.id}
                                                    sx={{
                                                        backgroundColor: excludedQuestions.includes(question.id)
                                                            ? colors.primary[700]
                                                            : colors.primary[600],
                                                        opacity: excludedQuestions.includes(question.id) ? 0.6 : 1,
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s',
                                                        '&:hover': {
                                                            boxShadow: `0 0 10px ${colors.blueAccent[500]}`,
                                                            transform: 'translateY(-2px)',
                                                        },
                                                    }}
                                                    onClick={() => {
                                                        // Open PDF and jump to question's page
                                                        setSelectedPDFPage(question.page);
                                                        if (!showPDF) {
                                                            setShowPDF(true);
                                                        }
                                                    }}
                                                >
                                                    <CardContent>
                                                        <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={2}>
                                                            <Box flex={1}>
                                                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                                                    <Typography variant="h5" fontWeight="bold">
                                                                        Page {question.page} | Q {question.question_label}
                                                                    </Typography>
                                                                    <Typography variant="caption" color={colors.blueAccent[400]} sx={{ fontStyle: 'italic' }}>
                                                                        (click to view in PDF)
                                                                    </Typography>
                                                                </Box>
                                                                {question.passage && (
                                                                    <Box
                                                                        sx={{
                                                                            mt: 1,
                                                                            p: 2,
                                                                            bgcolor: colors.blueAccent[800],
                                                                            borderRadius: '4px',
                                                                        }}
                                                                    >
                                                                        <Typography variant="caption" fontWeight="bold" color={colors.blueAccent[300]}>
                                                                            Passage:
                                                                        </Typography>
                                                                        <QuestionRender content={question.passage} />
                                                                    </Box>
                                                                )}
                                                                {question.content && (
                                                                    <Box sx={{ mt: 1 }}>
                                                                        <QuestionRender content={question.content} />
                                                                    </Box>
                                                                )}
                                                                {question.options && question.options.length > 0 && (
                                                                    <Box sx={{ mt: 1 }}>
                                                                        <Typography variant="caption" fontWeight="bold">Options:</Typography>
                                                                        <RadioGroup value="">
                                                                            {question.options.map((option, idx) => {
                                                                                // Helper to check if an answer matches an index
                                                                                const isCorrectAnswer = (answer, index) => {
                                                                                    if (typeof answer === 'number') return answer === index;
                                                                                    if (typeof answer === 'string') {
                                                                                        const num = parseInt(answer, 10);
                                                                                        // Only match if it's a pure numeric string
                                                                                        return !isNaN(num) && String(num) === answer.trim() && num === index;
                                                                                    }
                                                                                    return false;
                                                                                };

                                                                                const isCorrect = Array.isArray(question.answer)
                                                                                    ? question.answer.some(ans => isCorrectAnswer(ans, idx))
                                                                                    : isCorrectAnswer(question.answer, idx);

                                                                                return (
                                                                                    <Box key={idx} sx={{ ml: 1, mt: 0.5, display: 'flex', alignItems: 'flex-start' }}>
                                                                                        <Radio
                                                                                            checked={isCorrect}
                                                                                            disabled
                                                                                            size="small"
                                                                                            sx={{
                                                                                                p: 0.5,
                                                                                                color: isCorrect ? colors.greenAccent[400] : undefined,
                                                                                                '&.Mui-checked': {
                                                                                                    color: colors.greenAccent[400],
                                                                                                },
                                                                                            }}
                                                                                        />
                                                                                        <Box sx={{ ml: 0.5 }}>
                                                                                            <QuestionRender content={option} />
                                                                                        </Box>
                                                                                    </Box>
                                                                                );
                                                                            })}
                                                                        </RadioGroup>
                                                                    </Box>
                                                                )}
                                                                {question.answer && question.answer.length > 0 && (
                                                                    <Box sx={{ mt: 2, p: 1.5, bgcolor: colors.greenAccent[800], borderRadius: '4px' }}>
                                                                        <Typography variant="caption" fontWeight="bold" color={colors.greenAccent[300]}>
                                                                            Correct Answer(s):
                                                                        </Typography>
                                                                        <Box sx={{ mt: 0.5 }}>
                                                                            {question.answer_tool === 'coordinate' ? (
                                                                                formatCoordinateAnswerDisplay(question.answer, question.answer_config, colors)
                                                                            ) : question.answer_tool === 'table' ? (
                                                                                // Table answer - show visual table
                                                                                (() => {
                                                                                    const config = question.answer_config || defaultTableConfig;
                                                                                    // Build answer from config's cell values
                                                                                    const answerFromConfig = {
                                                                                        rows: (config.rows || []).map(row => ({
                                                                                            id: row.id,
                                                                                            cells: Object.fromEntries(
                                                                                                Object.entries(row.cells || {}).map(([colId, cell]) => [
                                                                                                    colId,
                                                                                                    cell?.value || ''
                                                                                                ])
                                                                                            )
                                                                                        }))
                                                                                    };
                                                                                    return (
                                                                                        <TableReadOnly
                                                                                            config={config}
                                                                                            studentAnswer={answerFromConfig}
                                                                                            showCorrect={false}
                                                                                        />
                                                                                    );
                                                                                })()
                                                                            ) : question.answer_tool === 'mapping' ? (
                                                                                // Mapping answer - show visual mapping
                                                                                (() => {
                                                                                    const config = question.answer_config || defaultMappingConfig;
                                                                                    const answerString = Array.isArray(question.answer)
                                                                                        ? question.answer[0]
                                                                                        : (question.answer || '{"connections": []}');
                                                                                    return (
                                                                                        <MappingReadOnly
                                                                                            config={config}
                                                                                            studentAnswer={answerString}
                                                                                            correctAnswer={answerString}
                                                                                            showCorrectAnswer={false}
                                                                                            showGradeBadge={false}
                                                                                        />
                                                                                    );
                                                                                })()
                                                                            ) : question.answer_tool === 'polynomialGraph' ? (
                                                                                (() => {
                                                                                    let answerData = { correctGraphIndex: 0 };
                                                                                    try {
                                                                                        if (question.answer && question.answer[0]) {
                                                                                            answerData = typeof question.answer[0] === 'string'
                                                                                                ? JSON.parse(question.answer[0]) : question.answer[0];
                                                                                        }
                                                                                    } catch (e) {
                                                                                        console.error('Error parsing polynomial graph answer:', e);
                                                                                    }
                                                                                    return (
                                                                                        <PolynomialGraphReadOnly
                                                                                            config={question.answer_config || defaultPolynomialGraphConfig}
                                                                                            studentAnswer={answerData}
                                                                                            correctAnswer={answerData}
                                                                                        />
                                                                                    );
                                                                                })()
                                                                            ) : question.answer_tool === 'rationalGraph' ? (
                                                                                (() => {
                                                                                    let answerData = { correctGraphIndex: 0 };
                                                                                    try {
                                                                                        if (question.answer && question.answer[0]) {
                                                                                            answerData = typeof question.answer[0] === 'string'
                                                                                                ? JSON.parse(question.answer[0]) : question.answer[0];
                                                                                        }
                                                                                    } catch (e) {
                                                                                        console.error('Error parsing rational graph answer:', e);
                                                                                    }
                                                                                    return (
                                                                                        <RationalGraphReadOnly
                                                                                            config={question.answer_config || defaultRationalGraphConfig}
                                                                                            studentAnswer={answerData}
                                                                                            correctAnswer={answerData}
                                                                                        />
                                                                                    );
                                                                                })()
                                                                            ) : question.answer_tool === 'trigGraph' ? (
                                                                                (() => {
                                                                                    let answerData = { correctGraphIndex: 0 };
                                                                                    try {
                                                                                        if (question.answer && question.answer[0]) {
                                                                                            answerData = typeof question.answer[0] === 'string'
                                                                                                ? JSON.parse(question.answer[0]) : question.answer[0];
                                                                                        }
                                                                                    } catch (e) {
                                                                                        console.error('Error parsing trig graph answer:', e);
                                                                                    }
                                                                                    return (
                                                                                        <TrigGraphReadOnly
                                                                                            config={question.answer_config || defaultTrigGraphConfig}
                                                                                            studentAnswer={answerData}
                                                                                            correctAnswer={answerData}
                                                                                        />
                                                                                    );
                                                                                })()
                                                                            ) : question.answer_tool === 'numberline' ? (
                                                                                (() => {
                                                                                    let answerData = { elements: [] };
                                                                                    try {
                                                                                        if (question.answer && question.answer[0]) {
                                                                                            answerData = typeof question.answer[0] === 'string'
                                                                                                ? JSON.parse(question.answer[0]) : question.answer[0];
                                                                                        }
                                                                                    } catch (e) {
                                                                                        // Malformed numberline answer JSON — fall back to empty elements
                                                                                    }
                                                                                    return (
                                                                                        <NumberLineReadOnly
                                                                                            config={question.answer_config || defaultNumberLineConfig}
                                                                                            studentAnswer={answerData}
                                                                                            showCorrect={false}
                                                                                        />
                                                                                    );
                                                                                })()
                                                                            ) : question.answer_tool === 'multiline' ? (
                                                                                (() => {
                                                                                    let answerData = { rows: [] };
                                                                                    try {
                                                                                        if (question.answer && question.answer[0]) {
                                                                                            answerData = typeof question.answer[0] === 'string'
                                                                                                ? JSON.parse(question.answer[0]) : question.answer[0];
                                                                                        }
                                                                                    } catch (e) {
                                                                                        // Malformed answer JSON — fall back to empty rows
                                                                                    }
                                                                                    return (
                                                                                        <MultilineReadOnly
                                                                                            config={question.answer_config || defaultMultilineConfig}
                                                                                            studentAnswer={answerData}
                                                                                            showCorrect={false}
                                                                                        />
                                                                                    );
                                                                                })()
                                                                            ) : question.answer_tool === 'mathlive' ? (
                                                                                (() => {
                                                                                    const answers = Array.isArray(question.answer)
                                                                                        ? question.answer
                                                                                        : [question.answer];
                                                                                    return answers.map((rawAns, idx) => {
                                                                                        const parsed = parseMathliveAnswer(rawAns);
                                                                                        if (parsed?.type === MATHLIVE_ANSWER_TYPES.TEXT) {
                                                                                            return (
                                                                                                <Box key={idx} sx={{ ml: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                                                    <Chip label="Text" size="small" />
                                                                                                    <Typography variant="body2">{parsed.value}</Typography>
                                                                                                </Box>
                                                                                            );
                                                                                        }
                                                                                        return (
                                                                                            <Box key={idx} sx={{ ml: 1 }}>
                                                                                                <QuestionRender content={String(parsed?.value ?? rawAns ?? '')} />
                                                                                            </Box>
                                                                                        );
                                                                                    });
                                                                                })()
                                                                            ) : Array.isArray(question.answer) ? (
                                                                                question.answer.map((ans, idx) => {
                                                                                    // For multiple choice, convert index to option text
                                                                                    const displayAnswer = question.question_type === 'multiple_choice' && question.options
                                                                                        ? (question.options[parseInt(ans, 10)] || ans)
                                                                                        : ans;
                                                                                    return (
                                                                                        <Box key={idx} sx={{ ml: 1 }}>
                                                                                            <QuestionRender content={String(displayAnswer)} />
                                                                                        </Box>
                                                                                    );
                                                                                })
                                                                            ) : (
                                                                                <QuestionRender content={
                                                                                    question.question_type === 'multiple_choice' && question.options
                                                                                        ? (question.options[parseInt(question.answer, 10)] || question.answer)
                                                                                        : question.answer
                                                                                } />
                                                                            )}
                                                                        </Box>
                                                                    </Box>
                                                                )}
                                                            </Box>
                                                            <FormControlLabel
                                                                onClick={(e) => e.stopPropagation()}
                                                                control={
                                                                    <Checkbox
                                                                        checked={!excludedQuestions.includes(question.id)}
                                                                        onChange={(e) => {
                                                                            if (e.target.checked) {
                                                                                // Include question (remove from excluded)
                                                                                setExcludedQuestions(excludedQuestions.filter(id => id !== question.id));
                                                                                setExcludedQuestionLabels(excludedQuestionLabels.filter(label => label !== question.question_label));
                                                                            } else {
                                                                                // Exclude question (add to excluded)
                                                                                setExcludedQuestions([...excludedQuestions, question.id]);
                                                                                setExcludedQuestionLabels([...excludedQuestionLabels, question.question_label]);
                                                                            }
                                                                        }}
                                                                    />
                                                                }
                                                                label="Include"
                                                            />
                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            ))}
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                            </>) : null}
                        </>) : (
                            <Box
                                display="flex"
                                minWidth="100%"
                                flexDirection="column"
                                justifyContent="flex-start"
                                sx={{
                                    gap: "1rem",
                                    ...matches && {
                                        justifyContent: "space-between",
                                        flexDirection: "row",
                                    },
                                }}
                            >
                                <UploadComp files={files} setFiles={setFiles} />
                            </Box>
                        )}
                        <Button
                            type="submit"
                            variant="contained"
                            disabled={userRole === 'teacher' && !allowFileUpload && !allowHwQuestions}
                            style={{
                                backgroundColor: colors.primary[300],
                                color: "white",
                                float: "right",
                                marginTop: "0.5rem",
                                marginBottom: "1rem",
                                width: "10rem",
                            }}
                        >
                            Create
                        </Button>
                    </Box>
                </AccordionDetails>
                <ErrorSnackbar errorMsg="Please select module and set due date!" open={errorSnackbarOpen} setOpen={setErrorSnackbarOpen} />
            </Accordion>
        </div>
    )
}